import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "upload",
  "use": "upload-usage",
  "viewBox": "0 0 12 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 16\" id=\"upload\"><path d=\"M6.259.7c-.1-.1-.2-.1-.3-.1-.1 0-.2 0-.3.1l-5.2 4.9c-.1.1-.1.2-.1.3 0 .1 0 .2.1.3.1.1.2.1.3.1h3.4v6c0 .1 0 .2.1.3.1.1.2.1.3.1h2.7c.1 0 .2 0 .3-.1.1-.1.1-.2.1-.3V6.4h3.5c.2 0 .3-.1.4-.3.1-.2 0-.3-.1-.5L6.259.7zM11.1 13.6H.9c-.3 0-.6.3-.6.6v.6c0 .3.3.6.6.6h10.2c.3 0 .6-.3.6-.6v-.6c0-.3-.3-.6-.6-.6z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol